export default {
    monthly: 'รายเดือน',
    exportPDF: 'ดาวน์โหลด PDF',
    exportExcel: 'ดาวน์โหลด EXCEL',
    selectAll: 'เลือกทั้งหมด'
}
